import { Typography } from '@mui/material';
import styled from 'styled-components/macro';

const Value = styled(Typography)`
  padding: 0 8px;
`;

export const ComparisonStyles = {
  Value,
};
